/**
 * `paymentKeys` here only carries the `customer` branch this slice owns.
 * `src/lib/query-keys.ts` composes it with the `vendor-payments` branch into
 * the combined shape `portal-payments/utils.ts` needs.
 */
export const paymentKeys = {
  customer: {
    all: ["customer-payments"] as const,
    lists: () => [...paymentKeys.customer.all, "list"] as const,
    list: (filters: Record<string, unknown>) => [...paymentKeys.customer.lists(), filters] as const,
    totals: (filters: Record<string, unknown>) =>
      [...paymentKeys.customer.all, "totals", filters] as const,
    details: () => [...paymentKeys.customer.all, "detail"] as const,
    detail: (id: string) => [...paymentKeys.customer.details(), id] as const,
    // Nested under `detail(id)` so invalidating the payment also invalidates
    // its relationship graph.
    related: (id: string) => [...paymentKeys.customer.detail(id), "related"] as const,
  },
};
